// Axios
import axios from 'axios'
import router from "@/router"
import {useUserStore} from '@/plugins/store'

// Configuration
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:8081' : '/api'
axios.defaults.withCredentials = process.env.NODE_ENV === 'development'
console.log(`Using API URL: ${axios.defaults.baseURL}`)

export const rustApi = axios.create({
    baseURL:
        process.env.NODE_ENV === 'development'
            ? 'http://localhost:8070'
            : '/rust-api',
    withCredentials: process.env.NODE_ENV === 'development'
})

rustApi.interceptors.response.use(
    response => {
        // Valid code (2xx)
        return response
    },
    error => {
        console.log('Rust API error:', error)
        console.log('Status:', error.response?.status)
        console.log('Response:', error.response?.data)

        return Promise.reject(error)
    }
)

// Update login secret when user is set

// Logout if login secret is revoked
axios.interceptors.response.use(undefined, (error) => {
    if (error) {
        const originalRequest = error.config;
        if (error?.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            let store = useUserStore()
            store.logout()
            return router.go()
        }
        
        console.log('Kotlin API error:', error)
        console.log('Status:', error.response?.status)
        console.log('Response:', error.response?.data)

        return Promise.reject(error)
    }
})

export default axios
